var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * 
 * @file Details sidebar component
 * @author Box
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import noop from 'lodash/noop';
import getProp from 'lodash/get';
import messages from '../messages';
import { SECTION_TARGETS } from '../../interactionTargets';
import SidebarAccessStats from './SidebarAccessStats';
import SidebarSection from './SidebarSection';
import SidebarContent from './SidebarContent';
import SidebarVersions from './SidebarVersions';
import SidebarNotices from './SidebarNotices';
import SidebarFileProperties from './SidebarFileProperties';
import APIContext from '../APIContext';
import { HTTP_STATUS_CODE_FORBIDDEN, FIELD_METADATA_CLASSIFICATION } from '../../constants';
import API from '../../api'; // eslint-disable-line

var DetailsSidebar = function (_React$PureComponent) {
    _inherits(DetailsSidebar, _React$PureComponent);

    function DetailsSidebar(props) {
        _classCallCheck(this, DetailsSidebar);

        var _this = _possibleConstructorReturn(this, (DetailsSidebar.__proto__ || Object.getPrototypeOf(DetailsSidebar)).call(this, props));

        _this.descriptionChangeSuccessCallback = function (file) {
            _this.setState({ file: file, fileError: undefined });
        };

        _this.descriptionChangeErrorCallback = function (file) {
            // Reset the state back to the original description since the API call failed
            _this.setState({
                file: file,
                fileError: {
                    inlineError: {
                        title: messages.fileDescriptionInlineErrorTitleMessage,
                        content: messages.defaultInlineErrorContentMessage
                    }
                }
            });
        };

        _this.onDescriptionChange = function (newDescription) {
            var api = _this.props.api;
            var file = _this.state.file;
            var description = file.description;

            if (newDescription === description) {
                return;
            }

            api.getFileAPI().setFileDescription(file, newDescription, _this.descriptionChangeSuccessCallback, _this.descriptionChangeErrorCallback);
        };

        _this.fetchAccessStatsErrorCallback = function (error) {
            var accessStatsError = void 0;

            if (getProp(error, 'status') === HTTP_STATUS_CODE_FORBIDDEN) {
                accessStatsError = {
                    error: messages.fileAccessStatsPermissionsError
                };
            } else {
                accessStatsError = {
                    maskError: {
                        errorHeader: messages.fileAccessStatsErrorHeaderMessage,
                        errorSubHeader: messages.defaultErrorMaskSubHeaderMessage
                    }
                };
            }

            _this.setState({
                isLoading: false,
                accessStats: undefined,
                accessStatsError: accessStatsError
            });
        };

        _this.fetchAccessStatsSuccessCallback = function (accessStats) {
            _this.setState({
                accessStats: accessStats,
                accessStatsError: undefined,
                isLoading: false
            });
        };

        _this.classifiationChangeSuccessCallback = function (file) {
            _this.setState({
                file: file,
                isLoading: false
            });
        };

        _this.classifiationChangeErrorCallback = function () {
            _this.setState({
                isLoading: false
            });
        };

        _this.onClassificationChange = function () {
            var file = _this.state.file;
            var api = _this.props.api;

            _this.setState({ isLoading: true });
            api.getFileAPI().getFile(file.id, _this.classifiationChangeSuccessCallback, _this.classifiationChangeErrorCallback, {
                forceFetch: true,
                updateCache: true,
                fields: [FIELD_METADATA_CLASSIFICATION]
            });
        };

        _this.onClassificationClick = function () {
            var onClassificationClick = _this.props.onClassificationClick;

            onClassificationClick(_this.onClassificationChange);
        };

        _this.state = {
            file: props.file,
            isLoading: false
        };
        return _this;
    }

    _createClass(DetailsSidebar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var hasAccessStats = this.props.hasAccessStats;

            if (hasAccessStats) {
                this.fetchAccessStats();
            }
        }

        /**
         * File description update callback
         *
         * @private
         * @param {BoxItem} file - Updated file object
         * @return {void}
         */


        /**
         * Handles a failed file description update
         *
         * @private
         * @param {BoxItem} file - Original file object
         * @return {void}
         */


        /**
         * Function to update file description
         *
         * @private
         * @param {string} newDescription - New file description
         * @return {void}
         */


        /**
         * Handles a failed file access stats fetch
         *
         * @private
         * @param {Error} e - API error
         * @return {void}
         */


        /**
         * File access stats fetch success callback
         *
         * @private
         * @param {Object} accessStats - access stats for a file
         * @return {void}
         */

    }, {
        key: 'fetchAccessStats',


        /**
         * Fetches the access stats for a file
         *
         * @private
         * @return {void}
         */
        value: function fetchAccessStats() {
            var api = this.props.api;
            var file = this.state.file;

            this.setState({ isLoading: true });
            api.getFileAccessStatsAPI(false).get({
                id: file.id,
                successCallback: this.fetchAccessStatsSuccessCallback,
                errorCallback: this.fetchAccessStatsErrorCallback
            });
        }

        /**
         * Sucess callback for classification change
         *
         * @private
         * @return {void}
         */


        /**
         * Error callback for classification change
         *
         * @private
         * @return {void}
         */


        /**
         * Refreshes sidebar when classification is changed
         *
         * @private
         * @return {void}
         */


        /**
         * Add classification click handler
         *
         * @private
         * @return {void}
         */

    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                hasProperties = _props.hasProperties,
                hasNotices = _props.hasNotices,
                hasAccessStats = _props.hasAccessStats,
                hasClassification = _props.hasClassification,
                hasRetentionPolicy = _props.hasRetentionPolicy,
                hasVersions = _props.hasVersions,
                onAccessStatsClick = _props.onAccessStatsClick,
                onVersionHistoryClick = _props.onVersionHistoryClick,
                onRetentionPolicyExtendClick = _props.onRetentionPolicyExtendClick,
                retentionPolicy = _props.retentionPolicy,
                bannerPolicy = _props.bannerPolicy;
            var _state = this.state,
                accessStats = _state.accessStats,
                accessStatsError = _state.accessStatsError,
                file = _state.file,
                fileError = _state.fileError,
                isLoading = _state.isLoading;


            return React.createElement(
                SidebarContent,
                {
                    title: React.createElement(FormattedMessage, messages.sidebarDetailsTitle)
                },
                hasNotices && React.createElement(
                    'div',
                    { className: 'bcs-details-content' },
                    hasNotices && React.createElement(SidebarNotices, { file: file })
                ),
                hasAccessStats && React.createElement(SidebarAccessStats, _extends({
                    accessStats: accessStats,
                    onAccessStatsClick: onAccessStatsClick,
                    file: file
                }, accessStatsError)),
                hasVersions && React.createElement(
                    'div',
                    { className: 'bcs-details-content' },
                    hasVersions && React.createElement(SidebarVersions, {
                        onVersionHistoryClick: onVersionHistoryClick,
                        file: file
                    })
                ),
                hasProperties && React.createElement(
                    SidebarSection,
                    {
                        interactionTarget: SECTION_TARGETS.FILE_PROPERTIES,
                        title: React.createElement(FormattedMessage, messages.sidebarProperties)
                    },
                    React.createElement(SidebarFileProperties, _extends({
                        onDescriptionChange: this.onDescriptionChange,
                        file: file
                    }, fileError, {
                        hasClassification: hasClassification,
                        onClassificationClick: this.onClassificationClick,
                        hasRetentionPolicy: hasRetentionPolicy,
                        retentionPolicy: retentionPolicy,
                        bannerPolicy: bannerPolicy,
                        onRetentionPolicyExtendClick: onRetentionPolicyExtendClick,
                        isLoading: isLoading
                    }))
                )
            );
        }
    }]);

    return DetailsSidebar;
}(React.PureComponent);

DetailsSidebar.defaultProps = {
    hasNotices: false,
    hasProperties: false,
    hasAccessStats: false,
    hasClassification: false,
    hasRetentionPolicy: false,
    hasVersions: false,
    onClassificationClick: noop
};

export { DetailsSidebar as DetailsSidebarComponent };
export default (function (props) {
    return React.createElement(
        APIContext.Consumer,
        null,
        function (api) {
            return React.createElement(DetailsSidebar, _extends({}, props, { api: api }));
        }
    );
});